// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:44:46.837Z
// Property: Park Village of Paris (ID: 6767906449167518)
// Collections: 33 amenities, 3 floorplans (live), 33 photos, 32 POIs, 5 reviews, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167518",
  "property_external_id": "5685517",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/park-village-of-paris-paris-tn/petm49v/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+Village+Apartments/@36.3247937,-88.3253977,954m/data=!3m2!1e3!4b1!4m6!3m5!1s0x887bbcb32a75b557:0x3a242d786f6104e3!8m2!3d36.3247937!4d-88.3253977!16s%2Fg%2F1td3mbqm?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58524941663",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-place-village-of-paris",
  "property_name": "Park Village of Paris",
  "property_website_url": "https://www.parkvillageapartmentliving.com/",
  "property_domain": "https://www.parkvillageapartmentliving.com/",
  "property_address": "1450 N Market St",
  "property_full_address": "1450 N Market St, Paris, TN 38242",
  "property_address_1": "1450 N Market St",
  "property_address_2": null,
  "property_address_city": "Paris",
  "property_address_state": "TN",
  "property_address_zip_full": "38242-3257",
  "property_address_zip": "38242",
  "property_address_country": "US",
  "property_address_county": "Henry County",
  "property_neighborhood_address": "Tennessee West Area",
  "property_address_latitude": "36.3249231",
  "property_address_longitude": "-88.3254493",
  "property_email": "parkvillageapartments@dietzpropertygroup.com",
  "property_phone": "(731) 642-3992",
  "property_call_tracking_phone": "731-642-3992",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Park Place Village of Paris, find the perfect blend of comfort and style in our spacious two, three, or four-bedroom apartments. Enjoy modern amenities like central air, walk-in closets, and private patios. Experience personalized service from our on-site management team. Your new home awaits—schedule a tour today!",
  "property_long_description": "Welcome to Park Place Village of Paris, your ideal home in the heart of picturesque Paris, TN. Our thoughtfully designed apartment community features a variety of spacious floor plans, including two, three, and four-bedroom options, ensuring there’s a perfect fit for everyone. Each apartment boasts modern amenities, including a private patio for relaxation, abundant walk-in closets for your storage needs, and central air conditioning to keep you cool year-round.\n\nEnjoy the convenience of a fully equipped kitchen featuring a dishwasher and disposal, along with the ease of full-size washer and dryer laundry hook-ups available in select units. With mini blinds included, you can control the natural light that floods your new home. Our on-site professional management team is dedicated to providing exceptional service, making your living experience as enjoyable as possible. \n\nIn addition to our spacious interiors, Park Place Village offers a welcoming community atmosphere with features that enhance your lifestyle. Our on-site laundry facilities and private entrance for each apartment ensure privacy and ease. \n\nReady to elevate your living experience? Park Place Village of Paris is waiting for you! Find your new home today—browse our availability or schedule a tour to visit our community and see for yourself what makes us the perfect choice for your next apartment. Your dream home is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46eb-2068-7108-b6a1-7b594366bc11.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of an apartment building with white siding and brick accents, featuring blue shutters and balconies.",
    "public_id": "019e46eb-2068-7108-b6a1-7b594366bc11",
    "storage_key": "property/6767906449167518/019e46eb-2068-7108-b6a1-7b594366bc11.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "80",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "10",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "No more than 2 animals permitted per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). All pets must be spayed/neutered, over one year old, licensed, inoculated, and verified by veterinarian documentation.",
  "property_pet_policy_description": "CATS are allowed (max 20 lbs each). DOGS are allowed (max 75 lbs each). Additional deposit: $250 per cat or dog. Additional monthly rent: $10/month per cat or dog. No more than 2 animals permitted per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). All pets must be spayed/neutered, over one year old, licensed, inoculated, and verified by veterinarian documentation.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parkvillageapartmentstn.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019ef543-d012-702d-96d8-ff6880f75b2a.webp",
  "property_primary_logo_media": {
    "alt_text": "Park Village of Paris Apartments logo",
    "public_id": "019ef543-d012-702d-96d8-ff6880f75b2a",
    "storage_key": "property/6767906449167518/019ef543-d012-702d-96d8-ff6880f75b2a.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019ef543-d012-702d-96d8-ff6880f75b2a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Park Village of Paris Apartments logo",
    "public_id": "019ef543-d012-702d-96d8-ff6880f75b2a",
    "storage_key": "property/6767906449167518/019ef543-d012-702d-96d8-ff6880f75b2a.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019ef543-cfc3-777b-bd08-2498031d02be.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Park Village of Paris Apartments logo",
    "public_id": "019ef543-cfc3-777b-bd08-2498031d02be",
    "storage_key": "property/6767906449167518/019ef543-cfc3-777b-bd08-2498031d02be.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 4",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "778 - 1158",
  "property_sqft_min": "778",
  "property_sqft_max": "1158",
  "property_price_range": "786 - 1195",
  "property_price_min": "786",
  "property_price_max": "1195",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/marketplace/113210745360561/townhouses-for-rent/",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJV7V1KrO8e4gR4wRhb3gtJDo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/appliances-by-appointment-paris",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park Place Village of Paris",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "<p>Welcome to Park Village of Paris, where comfort meets convenience. Choose from spacious and affordable two, three, or four-bedroom apartments in Paris, TN, and enjoy amenities like an inviting picnic area, playground, and on-site laundry. With beautiful landscaping and easy access to shopping, your ideal home is waiting – experience the community vibe today!</p>",
  "property_home_floorplans_blurb": "Welcome to Park Village of Paris, where comfort meets style in the heart of Paris, TN. Choose from our spacious two, three, and four-bedroom apartments designed for modern living. Each floor plan offers unique features tailored to your needs. Browse our available homes and find your ideal space today!",
  "property_home_gallery_blurb": "Welcome to Park Village of Paris, where your ideal home awaits! Choose from spacious two, three, or four-bedroom floor plans, and enjoy top-notch amenities like on-site laundry, a BBQ picnic area, and beautiful landscaping. Experience comfort and convenience in the heart of Paris, TN. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Park Village of Paris, experience modern living in vibrant two, three, and four-bedroom floor plans. Nestled near heritage sites like the Paris Henry County Heritage Center and the picturesque Eiffel Tower Park, our community offers access to enriching local attractions. Uncover the best of Paris, TN, right at your doorstep!",
  "property_home_reviews_blurb": "At Park Village of Paris, our residents rave about the friendly environment and exceptional management. One happy tenant shared, \"Best decision I made was to move,\" highlighting the spacious apartments that elevate comfort for families. Experience the joy of living in a community that feels like home! ",
  "property_neighborhood_blurb": "<p>At Park Village of Paris, your new home is surrounded by vibrant community treasures. From the serene Eiffel Tower Park to the informative Paris Henry County Heritage Center, leisure and learning are just steps away. Discover a balance of comfort and convenience, with nearby amenities like the West Tennessee Healthcare Henry County Hospital and local fitness centers. Your ideal lifestyle awaits at our affordable apartment community in Paris, TN!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Park Village of Paris, comfort meets convenience with our diverse floor plans, including two to four-bedroom options. Enjoy lush landscaping and on-site amenities like picnic areas, laundry facilities, and a playground. With private entrances and modern features, your ideal home awaits in our affordable apartment community in Paris, TN.</p>",
  "property_applynow_blurb": "<p>Experience the charm of Park Village of Paris, offering the best affordable apartments in Paris, TN. Choose from spacious two, three, or four-bedroom floor plans, complete with private patios and walk-in closets. Enjoy amenities like a picnic area, on-site laundry, and attentive management—all just moments from shopping. Lease online today for your new home!</p>",
  "property_contactus_blurb": "<p>At Park Village of Paris, we offer thoughtfully designed two, three, and four-bedroom floor plans tailored to fit your lifestyle. Enjoy spacious living where comfort meets community. Looking for affordable housing in Paris, TN? Contact our leasing team today and take the first step toward your new home!</p><p><br></p>",
  "property_faqs_blurb": "At Park Village of Paris, our thoughtfully designed two, three, and four-bedroom floor plans cater to diverse lifestyles. Nestled in the heart of Paris, TN, our community prioritizes comfort and convenience. Got questions? Our FAQs page is brimming with insights to help you learn more about your future home.",
  "property_floorplans_blurb": "<p>At Park Village of Paris, we offer thoughtfully designed two, three, and four-bedroom apartments to suit every lifestyle. Nestled in the heart of Paris, TN, our diverse floor plans provide the ideal backdrop for modern living. Browse our affordable apartment homes in Paris and find your perfect floor plan today!</p>",
  "property_gallery_blurb": "<p>At Park Village of Paris, our vibrant community invites you to envision life in our affordable two, three, or four-bedroom apartments in Paris, TN. Enjoy the delight of on-site amenities like a playground, picnic areas, and well-maintained landscapes. Let the charm of our community inspire your new beginning! Picture yourself living here!</p>",
  "property_interactivemap_blurb": "At Park Village of Paris, elevate your living experience with our spacious two, three, and four-bedroom apartments. Enjoy lush landscapes, community BBQs, and convenient on-site amenities while being minutes from shopping. Let our interactive community map guide you to your ideal home today—your stylish sanctuary awaits!",
  "property_pets_blurb": "<p>Park Village of Paris is your perfect pet-friendly escape. With ample space for your furry companions—up to two dogs or cats—our community ensures they feel at home while you enjoy modern comforts and vibrant living. Embrace a lifestyle where pets are cherished at our affordable two, three, and four-bedroom apartments in Paris, TN!</p>",
  "property_referafriend_blurb": "At Park Village of Paris, choose from spacious two, three, or four-bedroom floor plans that perfectly suit your lifestyle. Experience vibrant living in our welcoming community. Great friends make great neighbors—refer a friend today and start building lasting memories together in the heart of Paris, TN!",
  "property_residentaccess_blurb": "Welcome to Park Village of Paris, where spacious two, three, and four-bedroom floor plans are designed with your lifestyle in mind. Log in to your resident portal for seamless rent payments, hassle-free maintenance scheduling, and more—all at your fingertips! Enjoy the comfort and convenience of home in Paris, TN.",
  "property_reviews_blurb": "At Park Village of Paris, our residents aren't just happy; they thrive! With spacious apartments that make life feel more comfortable, family-friendly vibes, and management that truly cares, you’ll see why everyone is saying, \"Best decision I made was to move!\" Join our community and experience the difference for yourself!",
  "property_created_at": "1779306220543",
  "property_scheduletour_blurb": "<p>At Park Village of Paris, choose from spacious and affordable two, three, or four-bedroom apartments in Paris, TN. Our vibrant community welcomes you to experience comfort and convenience. Schedule a tour today and hear firsthand from our residents about their home sweet home!</p><p><br></p><p><br></p>",
  "property_thankyou_blurb": "Thank you for reaching out to Park Village of Paris! Nestled in the heart of Paris, TN, we offer spacious two, three, and four-bedroom floor plans designed for comfort and style. A team member will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "<p>Welcome to Park Village of Paris, where comfort meets style in our thoughtfully designed and affordable two, three, and four-bedroom apartments in Paris, TN. Immerse yourself in the charm of our community by taking a virtual tour today—your ideal home awaits! Experience spacious living at its finest!</p>",
  "property_copyright": "2026 All Rights Reserved. Park Place Village of Paris",
  "property_seo_title_home": "Affordable Apartments in Paris, TN | Park Village",
  "property_seo_description_home": "Discover Park Village of Paris, offering affordable apartments in Paris, TN. Enjoy pet-friendly living and spacious 2, 3 & 4-bedroom floor plans today.",
  "property_seo_title_floorplans": "Floor Plans | Affordable Apartments in Paris, TN",
  "property_seo_description_floorplans": "Explore spacious 2, 3 & 4-bedroom affordable apartments for rent in Paris, TN. Enjoy walk-in closets, dishwashers, balconies, and comfortable layouts today.",
  "property_seo_title_amenities": "Amenities | Pet Friendly, Affordable Apartments in Paris, TN",
  "property_seo_description_amenities": "Enjoy affordable apartments  in Paris, TN with balconies, dishwashers, pet-friendly amenities and more. Explore our community today!",
  "property_seo_title_gallery": "Gallery | Tax Credit Apartments Paris, TN",
  "property_seo_description_gallery": "Browse photos of Park Village of Paris' apartments, offering top interior and community amenities, pet-friendly spaces, and comfortable living in Paris.",
  "property_seo_title_virtualtours": "Virtual Tour | Affordable Apartments in Paris, TN",
  "property_seo_description_virtualtours": "Take a virtual tour of our Paris apartment community with balconies, dishwashers, and amenities near downtown Paris and nearby shopping, entertainment & more.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments for Rent in Paris, TN",
  "property_seo_description_interactivemap": "Start your leasing journey online. Explore the best apartment features, pet-friendly living, floor plans, and community amenities in Paris, TN.",
  "property_seo_title_neighborhood": "Neighborhood | Affordable Housing Paris, TN",
  "property_seo_description_neighborhood": "Enjoy affordable apartments in Paris, TN near shopping, dining, entertainment, healthcare, and more at Park Village of Paris.",
  "property_seo_title_contact": "Contact Us | Pet Friendly Apartments in Paris, TN",
  "property_seo_description_contact": "Contact Park Village of Paris in Paris, TN, for affordable 2, 3 & 4 bedroom apartments, pet-friendly features, availability, and floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Paris, TN",
  "property_seo_description_faqs": "Find answers to all your questions about Park Place Village of Paris! Learn about our spacious floor plans, modern amenities, and vibrant community today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Paris, TN",
  "property_seo_description_reviews": "Discover life at Park Place Village of Paris! Read resident reviews and find your ideal two to four-bedroom apartment with great amenities.",
  "property_seo_title_applynow": "Apply Now | Affordable Apartment Community in Paris, TN",
  "property_seo_description_applynow": "Apply online to affordable housing in Paris, TN. Enjoy pet-friendly living, and modern conveniences with us.",
  "property_seo_title_residentaccess": "Resident Access | Paris, TN Apartments",
  "property_seo_description_residentaccess": "Access online resident services, maintenance requests, payments, and community information at Park Village of Paris and rent in Paris, TN.",
  "property_seo_title_referafriend": "Refer A Friend | Park Place Village of Paris",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Park Place Village in Paris, TN, and enjoy the comfort of community living together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Paris, TN Apartments for Rent",
  "property_seo_description_scheduletour": "Schedule your tour of Park Village of Paris and explore spacious apartment homes, pet-friendly amenities, parking, and nearby attractions.",
  "property_seo_title_privacy": "Privacy Policy | Apartments in Paris, TN",
  "property_seo_description_privacy": "Discover how we protect your privacy on our website. Read our privacy policy for details and learn about our apartments for rent in Paris, TN.",
  "property_seo_title_accessibility": "Accessibility | Apartments in Paris, TN",
  "property_seo_description_accessibility": "Review accessibility information for Park Village of Paris and explore resources designed to enhance your website experience.",
  "property_seo_title_sitemap": "Sitemap | Apartments in Paris, TN",
  "property_seo_description_sitemap": "View the Park Village of Paris sitemap to quickly navigate floor plans, amenities, photos, leasing resources, and community information.",
  "property_seo_title_thankyou": "Thank You | Affordable Apartments Paris, TN",
  "property_seo_description_thankyou": "Thank you for your interest in Park Village of Paris Apartments. Our team will be in touch soon regarding availability, tours, and apartment living.",
  "property_seo_title_pets": "Pet Policy | Pet Friendly Apartments in Paris, TN",
  "property_seo_description_pets": "Learn about our pet policy, community guidelines, and pet-friendly apartment living near parks, shopping, and local services.",
  "property_updated_at": "1790198790057",
  "amenities": [
    {
      "id": "ec_6199a36600de6c452949af51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c03713456d0b14c69bc7e3ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8eb4c9e46738eb81883d50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffca622167de92e7d5b5820c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a92093bd29288451cfcab513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d038271e1223874bd4c6c1ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0af766229b62d4f22e52577",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffc0c0119b171ff647e9a28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_011a0c80f14b33c0f67f796c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_debb4dd6c18eb61ecd1fbca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Close to Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8a3d1af2b27e2b811530700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Full Size Washer and Dryer Laundry Hook Ups",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_323561d0c0a343deb54cb17d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4320f98add86f38f829b4d5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "On-site Laundry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57135363ebee5ae3d03d09a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bdf1f413037f873a31b38de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "On-site Management and Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f2f24bbd670016651a11a01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Areas With BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_011ea10c758621dbec75cf3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24550cbc0cece52064ee5c53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45ee549691fd49209bc50211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6af8aedc57a847fc3de49b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d9ab02d9e71250f3500dea7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_819aee02eb8f7a13563148d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_832bbd9bf30923ab892739ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bca84ea4beebaf09585c276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_528fc8f9ddcfaaaa1b42b1d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b622b9c8eba87bbf3badb7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_889c729a461fb28563e617ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f12bc340c04eaeda6c2e1451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af96627c124f04e27c74ec85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07735c7540ceb024a49f0565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4001cea5935a8bc0a8bb3e26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b3cf2bf4092a314fe8de456",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4665871b1a4d67cd2bc48b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2689c4da-96a3-4c58-b69d-133ecc487d6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-69b0-77de-996d-a53c7c970163.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing office at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-69b0-77de-996d-a53c7c970163",
        "storage_key": "property/6767906449167518/019e8f45-69b0-77de-996d-a53c7c970163.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Visit the leasing office at Park Place Village Apartments in Paris, TN for a tour of our beautiful community and available floor plans.",
      "link": "",
      "alt_text": "Exterior of the leasing office at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb9665fc-e5e4-4dcc-96bb-b9468daa59d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-7308-7162-b562-294fb3560b2e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, and dishwasher at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-7308-7162-b562-294fb3560b2e",
        "storage_key": "property/6767906449167518/019e8f45-7308-7162-b562-294fb3560b2e.webp",
        "width": 2016,
        "height": 1512
      },
      "title": "Apartment",
      "description": "View of a clean kitchen featuring white cabinetry, a double sink with a modern faucet, and a stainless steel dishwasher. A portion of a black refrigerator is visible.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel sink, and dishwasher at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e58b7f72-43c5-421b-86ce-395ac3e046b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-73b0-76de-8b1b-ec0b118660a9.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and electric range in apartment kitchen.",
        "public_id": "019e8f45-73b0-76de-8b1b-ec0b118660a9",
        "storage_key": "property/6767906449167518/019e8f45-73b0-76de-8b1b-ec0b118660a9.webp",
        "width": 2016,
        "height": 1512
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring a stainless steel refrigerator and electric range with ample counter space and wood-accented cabinetry.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and electric range in apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c2499b7-84d7-4fc1-af03-17c73963f4b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-58e1-77fd-9c70-0703e43deace.webp",
      "image_media": {
        "alt_text": "Empty living room with beige carpet and a large window at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-58e1-77fd-9c70-0703e43deace",
        "storage_key": "property/6767906449167518/019e8f45-58e1-77fd-9c70-0703e43deace.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring plush beige carpeting and a large window with blinds, offering a bright and airy atmosphere.",
      "link": "",
      "alt_text": "Empty living room with beige carpet and a large window at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93a59f67-dee5-4e13-92d1-e1cacd5e250d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-5304-707d-ba20-ab84ff5391ac.webp",
      "image_media": {
        "alt_text": "Empty apartment room with carpet and a window at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-5304-707d-ba20-ab84ff5391ac",
        "storage_key": "property/6767906449167518/019e8f45-5304-707d-ba20-ab84ff5391ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and neutral apartment room, perfect for personalization with your unique style. Features carpet flooring and ample natural light from a large window.",
      "link": "",
      "alt_text": "Empty apartment room with carpet and a window at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d78a8f2d-c6ac-4d3d-bdad-f461a2e3680e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-d821-710e-8f2a-e0e53c8e06f8.webp",
      "image_media": {
        "alt_text": "A small white dog being walked by its owners on a leash in a park at Park Place Village Apartments in Paris, TN.",
        "public_id": "019f054c-d821-710e-8f2a-e0e53c8e06f8",
        "storage_key": "property/6767906449167518/019f054c-d821-710e-8f2a-e0e53c8e06f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a leisurely stroll with your furry friend through our beautiful community grounds. We are a pet-friendly property!",
      "link": "",
      "alt_text": "A small white dog being walked by its owners on a leash in a park at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8b037ee-72de-4abc-ad8c-8d2cc96741af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-5b73-73c5-afa8-2fb912b724dd.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-5b73-73c5-afa8-2fb912b724dd",
        "storage_key": "property/6767906449167518/019e8f45-5b73-73c5-afa8-2fb912b724dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and a spacious vanity with a large mirror. Perfect for daily routines.",
      "link": "",
      "alt_text": "Bathroom with bathtub, toilet, and vanity at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5864c07e-f87c-4776-8ed6-b955950ce06f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-5fc4-725d-a267-4f491ff0a0a8.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and stove in a kitchen at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-5fc4-725d-a267-4f491ff0a0a8",
        "storage_key": "property/6767906449167518/019e8f45-5fc4-725d-a267-4f491ff0a0a8.webp",
        "width": 2016,
        "height": 1512
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, including a refrigerator and a smooth-top electric range with a digital display.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and stove in a kitchen at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c41a08f-be24-49c4-8e43-9723d3a02133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-3ad1-753b-a164-2c23eded2844.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a white door and a window with blinds at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-3ad1-753b-a164-2c23eded2844",
        "storage_key": "property/6767906449167518/019e8f45-3ad1-753b-a164-2c23eded2844.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A view of an empty bedroom, showcasing a carpeted floor, neutral walls, a closed white door, and a window with blinds.",
      "link": "",
      "alt_text": "Empty bedroom with a white door and a window with blinds at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a2727b6-a298-43bb-9253-c5d7aaacdd0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-3e50-755b-92b2-1f1f44180109.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, a closed white door, and a window with blinds at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-3e50-755b-92b2-1f1f44180109",
        "storage_key": "property/6767906449167518/019e8f45-3e50-755b-92b2-1f1f44180109.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This is an empty bedroom with plush carpeting and a large window, offering a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls, a closed white door, and a window with blinds at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_409d7ab0-455e-498d-b139-8d88ca4fa298",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-3a78-72bd-9289-7098558ef836.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet and window at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-3a78-72bd-9289-7098558ef836",
        "storage_key": "property/6767906449167518/019e8f45-3a78-72bd-9289-7098558ef836.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet and a bright window, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet and window at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3eb64bcf-02c9-435e-9839-1410dddd9a84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-43cb-7532-9fbd-a3522730fea2.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a large window at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-43cb-7532-9fbd-a3522730fea2",
        "storage_key": "property/6767906449167518/019e8f45-43cb-7532-9fbd-a3522730fea2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a full-length mirrored closet and a large window, offering ample natural light.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and a large window at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea5615e6-c47e-4ea6-9c06-d2db96b46a73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-42fd-727f-bcb1-307f22dff640.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and a window at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-42fd-727f-bcb1-307f22dff640",
        "storage_key": "property/6767906449167518/019e8f45-42fd-727f-bcb1-307f22dff640.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty bedroom features neutral-colored walls, plush carpeting, and a large window with blinds, offering a blank canvas for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and a window at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4da3eba9-8548-4c1f-87ec-fd3566ff826c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-272a-757b-8aab-b85e60e2c406.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with white siding and blue shutters at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-272a-757b-8aab-b85e60e2c406",
        "storage_key": "property/6767906449167518/019e8f45-272a-757b-8aab-b85e60e2c406.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment buildings, showcasing the clean white siding, blue shutters, and manicured landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment building with white siding and blue shutters at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27e0b22d-879a-4c6c-9a3b-594254c57494",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-cf8c-74e9-8833-df692a2923ff.webp",
      "image_media": {
        "alt_text": "A woman sitting on a couch and looking at her phone.",
        "public_id": "019f054c-cf8c-74e9-8833-df692a2923ff",
        "storage_key": "property/6767906449167518/019f054c-cf8c-74e9-8833-df692a2923ff.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "Relax and unwind in your new apartment while staying connected with friends and family.",
      "link": "",
      "alt_text": "A woman sitting on a couch and looking at her phone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02895984-0542-4d6b-a13b-53f4dc404b09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-2bf8-74fc-aaf3-005105fcc68e.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building complex with white siding and blue shutters at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-2bf8-74fc-aaf3-005105fcc68e",
        "storage_key": "property/6767906449167518/019e8f45-2bf8-74fc-aaf3-005105fcc68e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of the apartment buildings showcases a blend of white siding and brick accents, complemented by blue shutters and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of the apartment building complex with white siding and blue shutters at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4627227-ab1a-41a5-bc23-2c282bc62d18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-35a0-73c4-b7cc-cb6de2d6e875.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment with carpeted floors and multiple doorways at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-35a0-73c4-b7cc-cb6de2d6e875",
        "storage_key": "property/6767906449167518/019e8f45-35a0-73c4-b7cc-cb6de2d6e875.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment interior featuring neutral carpet and a bright, airy feel with views into adjoining rooms.",
      "link": "",
      "alt_text": "Interior view of an apartment with carpeted floors and multiple doorways at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29b30499-e337-47b8-b58d-1e7e6550d983",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-335a-766c-9a64-9a8210732bc9.webp",
      "image_media": {
        "alt_text": "Empty room with a window and carpet at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-335a-766c-9a64-9a8210732bc9",
        "storage_key": "property/6767906449167518/019e8f45-335a-766c-9a64-9a8210732bc9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and carpeted room featuring a large window with blinds, perfect for any decor.",
      "link": "",
      "alt_text": "Empty room with a window and carpet at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_387c52a2-ed9b-45ec-98a8-636573eaa85f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-2e45-7584-8d39-8eb12fe785c7.webp",
      "image_media": {
        "alt_text": "Empty closet with a single white shelf at Park Place Village Apartments in Paris, TN.",
        "public_id": "019e8f45-2e45-7584-8d39-8eb12fe785c7",
        "storage_key": "property/6767906449167518/019e8f45-2e45-7584-8d39-8eb12fe785c7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty closet features a simple white wire shelf, ready for your organizational needs.",
      "link": "",
      "alt_text": "Empty closet with a single white shelf at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8087955-b1b1-4307-a929-f78ac49b03f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-bdf5-779f-a30b-8a1213835635.webp",
      "image_media": {
        "alt_text": "A man gently pets a tabby kitten indoors near a window, showcasing a pet-friendly environment at Park Place Village Apartments in Paris, TN.",
        "public_id": "019f054c-bdf5-779f-a30b-8a1213835635",
        "storage_key": "property/6767906449167518/019f054c-bdf5-779f-a30b-8a1213835635.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Our pet-friendly community welcomes your furry companions! Enjoy moments with your beloved pets in the comfort of your home.",
      "link": "",
      "alt_text": "A man gently pets a tabby kitten indoors near a window, showcasing a pet-friendly environment at Park Place Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_06770183-c6d9-4d36-b28f-f02f2bc7bbe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-108c-7478-80f9-ec55611d1adc.webp",
      "image_media": {
        "alt_text": "Park Village monument sign with address 1450 at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-108c-7478-80f9-ec55611d1adc",
        "storage_key": "property/6767906449167518/019e8f45-108c-7478-80f9-ec55611d1adc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Park Village, a community offering a comfortable living experience. This image features the property's monument sign with the address 1450.",
      "link": "",
      "alt_text": "Park Village monument sign with address 1450 at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f55c839-81c9-47a6-a361-3f1d11249f5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-128b-709a-bda4-41ca97f84260.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet and a large window overlooking the property at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-128b-709a-bda4-41ca97f84260",
        "storage_key": "property/6767906449167518/019e8f45-128b-709a-bda4-41ca97f84260.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring neutral tones and plush carpeting, perfect for creating your own personalized living space.",
      "link": "",
      "alt_text": "Empty living room with carpet and a large window overlooking the property at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a9ee8a65-52ca-42a7-9bfc-4618fb52ca6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-c56f-71b1-83c3-31b3ce730ea9.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together in their apartment kitchen at Park Village Apartments in Paris, TN.",
        "public_id": "019f054c-c56f-71b1-83c3-31b3ce730ea9",
        "storage_key": "property/6767906449167518/019f054c-c56f-71b1-83c3-31b3ce730ea9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a cozy meal together in your new apartment. Perfect for creating lasting memories.",
      "link": "",
      "alt_text": "Couple enjoying a meal together in their apartment kitchen at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b477ff38-7fa7-4a69-ad00-3c33b90a5ad3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-053e-73fd-b519-697bff019a14.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with blue shutters and dormer windows at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-053e-73fd-b519-697bff019a14",
        "storage_key": "property/6767906449167518/019e8f45-053e-73fd-b519-697bff019a14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of the apartment building shows multiple units with balconies and surrounding green space. Parking is available in the foreground.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with blue shutters and dormer windows at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de6a3eb8-8344-4b8a-b074-6b9ba56a1c17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f44-fd7a-718e-bc58-d57b9e79ae4c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, wood accents, white refrigerator, and white stove at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f44-fd7a-718e-bc58-d57b9e79ae4c",
        "storage_key": "property/6767906449167518/019e8f44-fd7a-718e-bc58-d57b9e79ae4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring ample cabinet space, a refrigerator, and a stove, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, wood accents, white refrigerator, and white stove at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_730079b7-0802-40d1-9dcb-e1b936b32d6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-c5e8-736b-9c96-99797c0d16b5.webp",
      "image_media": {
        "alt_text": "Two young women laughing while looking at a smartphone.",
        "public_id": "019f054c-c5e8-736b-9c96-99797c0d16b5",
        "storage_key": "property/6767906449167518/019f054c-c5e8-736b-9c96-99797c0d16b5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Two friends share a laugh while browsing content on a smartphone, embodying a vibrant and connected lifestyle.",
      "link": "",
      "alt_text": "Two young women laughing while looking at a smartphone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6aaa3722-7d11-4257-8621-ea3c5f43240e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-0614-7244-895d-f78ddeb66f4e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, oven, and sink at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-0614-7244-895d-f78ddeb66f4e",
        "storage_key": "property/6767906449167518/019e8f45-0614-7244-895d-f78ddeb66f4e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white appliances, ample cabinet space, and a double sink. Includes a separate area with hookups for a washer and dryer.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, oven, and sink at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33832288-87e8-4a33-b2df-5ec9e78548ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-04e1-7317-82e9-ecdcad1c939d.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with white siding and blue shutters at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-04e1-7317-82e9-ecdcad1c939d",
        "storage_key": "property/6767906449167518/019e8f45-04e1-7317-82e9-ecdcad1c939d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of a multi-unit apartment building on a cloudy day, showcasing its siding, windows, and balconies, with a well-maintained lawn in the foreground.",
      "link": "",
      "alt_text": "Exterior of apartment building with white siding and blue shutters at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f139c92-77cd-409e-b140-9ac384054479",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f45-052a-773e-a9fa-ae1ad1829b12.webp",
      "image_media": {
        "alt_text": "Exterior view of a light-colored apartment building with blue shutters and a green lawn at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f45-052a-773e-a9fa-ae1ad1829b12",
        "storage_key": "property/6767906449167518/019e8f45-052a-773e-a9fa-ae1ad1829b12.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the exterior of the apartment complex, featuring its architecture and surrounding green space. This image highlights the building's facade, window details, and the well-maintained lawn.",
      "link": "",
      "alt_text": "Exterior view of a light-colored apartment building with blue shutters and a green lawn at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_972fcde7-f2b5-4848-818b-550bc6e9d200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e8f44-fd74-700a-9f98-4a380699f519.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment unit showing the living room and a glimpse of the kitchen through a pass-through window at Park Village Apartments in Paris, TN.",
        "public_id": "019e8f44-fd74-700a-9f98-4a380699f519",
        "storage_key": "property/6767906449167518/019e8f44-fd74-700a-9f98-4a380699f519.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, a welcoming entryway, and an open-concept kitchen perfect for modern living.",
      "link": "",
      "alt_text": "Interior view of an apartment unit showing the living room and a glimpse of the kitchen through a pass-through window at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ec078ad-b93c-4021-be60-2944047844cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-d0bc-770a-b645-a86b5daa90fa.webp",
      "image_media": {
        "alt_text": "Man with beard and mustache smiling and holding a coffee mug, standing in a living room at Park Village Apartments in Paris, TN.",
        "public_id": "019f054c-d0bc-770a-b645-a86b5daa90fa",
        "storage_key": "property/6767906449167518/019f054c-d0bc-770a-b645-a86b5daa90fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a moment of relaxation in your stylish apartment. Our spacious living areas are perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Man with beard and mustache smiling and holding a coffee mug, standing in a living room at Park Village Apartments in Paris, TN.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fb84be8-182f-4cce-85b1-d85e8cbfcec3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-d565-7055-ac3d-412bf8684ec9.webp",
      "image_media": {
        "alt_text": "A couple looking at a phone together, with a laptop and notebook on the table.",
        "public_id": "019f054c-d565-7055-ac3d-412bf8684ec9",
        "storage_key": "property/6767906449167518/019f054c-d565-7055-ac3d-412bf8684ec9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple is engaged in conversation while looking at a smartphone, suggesting collaboration or shared activity in a home or office setting.",
      "link": "",
      "alt_text": "A couple looking at a phone together, with a laptop and notebook on the table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a546776c-7365-4219-a8a0-2556e3efac75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019f054c-c191-74f8-84bd-3f014dbe68fc.webp",
      "image_media": {
        "alt_text": "Father lifting his laughing son in the air indoors.",
        "public_id": "019f054c-c191-74f8-84bd-3f014dbe68fc",
        "storage_key": "property/6767906449167518/019f054c-c191-74f8-84bd-3f014dbe68fc.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father and son share a joyful moment, lifting and laughing together in a bright, indoor setting. This image evokes happiness and family connection.",
      "link": "",
      "alt_text": "Father lifting his laughing son in the air indoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3a2d9a6b-c92b-4ea5-8ff9-2ea300c4a6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Moustos Pasta & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1305 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "Comfortable restaurant featuring Italian food such as chicken marsala and seafood tortellini, plus a full bar.",
      "poi_long_description": "Diners like this Italian restaurant's delicious and authentic food, with many highlighting the generous portions of pasta, steak, and salad. They also mention the reasonable prices and the beautiful, inviting atmosphere, including a waterfall in the foyer. Guests consistently praise the friendly, attentive, and efficient service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-5cc7-7494-a1f9-7cfb5988e3cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-5cc7-7494-a1f9-7cfb5988e3cd",
        "storage_key": "property/6767906449167518/019e46ea-5cc7-7494-a1f9-7cfb5988e3cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.moustospastagrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3697811006095428196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moustos-pasta--grill",
      "poi_latitude": "36.30623420000001",
      "poi_longitude": "-88.2998193",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-407-9155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-771d-726b-a0da-fc0a675ff2b1",
        "storage_key": "property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9qxhguje4gRZArZqIRDUTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_94cbaa58-4492-4835-b19e-050c8660757b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Old West Steakhouse - Paris",
      "poi_type": "Restaurants",
      "poi_address": "1123 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "Laid-back restaurant featuring a buffet and a menu with fried dishes, steaks and chicken entrees.",
      "poi_long_description": "People say this steakhouse offers a buffet with fried catfish, fried chicken, and roasted chicken. They also highlight the reasonable prices, friendly service, and clean atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-5945-74cf-aabe-950f65b0ad5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-5945-74cf-aabe-950f65b0ad5e",
        "storage_key": "property/6767906449167518/019e46ea-5945-74cf-aabe-950f65b0ad5e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://oldwestrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=232671717403399618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-west-steakhouse---paris",
      "poi_latitude": "36.3030556",
      "poi_longitude": "-88.30583329999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-924-5180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-771d-726b-a0da-fc0a675ff2b1",
        "storage_key": "property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3_oG8yKje4gRwhUcubGdOgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d652bec7-5957-4465-931c-878e47fb5e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Oaklawn Southern Dining",
      "poi_type": "Restaurants",
      "poi_address": "1008 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "Popular upscale eatery serving steaks, scallops and seafood, plus cocktails and wine.",
      "poi_long_description": "Diners like this restaurant's exquisite cuisine, including perfectly cooked steaks, fresh seafood, and delicious cocktails, with many highlighting the complimentary valet service. They also mention the welcoming and attentive staff, who provide exceptional service and create a memorable experience. Guests appreciate the romantic and elegant atmosphere, making it ideal for special occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-58f2-749a-a0af-54dd6b3cf9be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-58f2-749a-a0af-54dd6b3cf9be",
        "storage_key": "property/6767906449167518/019e46ea-58f2-749a-a0af-54dd6b3cf9be.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.oaklawnsoutherndining.com/menus",
      "poi_directions_map_url": "https://maps.google.com/?cid=4994416012106300478&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oaklawn-southern-dining",
      "poi_latitude": "36.3026489",
      "poi_longitude": "-88.3090952",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 731-407-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-771d-726b-a0da-fc0a675ff2b1",
        "storage_key": "property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWxgSSje4gRPnwexua6T0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d83597bb-0061-4b1a-9bbf-a60fd8692600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Sweet Jordan's",
      "poi_type": "Restaurants",
      "poi_address": "849 Volunteer Dr Suite 1, Paris, TN 38242, USA",
      "poi_short_description": "Cookies, baked goods, coffee, ice cream, and sandwiches in a family-friendly setting with a play area.",
      "poi_long_description": "People say this cafe offers delicious homemade ice cream, exceptional coffee, and a variety of baked goods and sandwiches. They also highlight the welcoming, friendly atmosphere and the spotless interior. Guests mention the staff provides superb service and that it's a great place for families, especially with the kids' play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6041-753f-8079-2ac9ece72ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6041-753f-8079-2ac9ece72ddd",
        "storage_key": "property/6767906449167518/019e46ea-6041-753f-8079-2ac9ece72ddd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.sweetjordans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9470429671480136333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sweet-jordans",
      "poi_latitude": "36.28958739999999",
      "poi_longitude": "-88.30276549999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-642-0161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-771d-726b-a0da-fc0a675ff2b1",
        "storage_key": "property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_5FzOCie4gRjZLkFpy5bYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_95c21360-d4ec-4316-b8de-06b22be707bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "El Vallarta",
      "poi_type": "Restaurants",
      "poi_address": "1113 Mineral Wells Ave, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, enchiladas, and vegetarian options. They highlight the generous portions, reasonable prices, and convenient seating areas. They also like the friendly and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-5ba2-748f-ad7e-a9ac33767a33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-5ba2-748f-ad7e-a9ac33767a33",
        "storage_key": "property/6767906449167518/019e46ea-5ba2-748f-ad7e-a9ac33767a33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=820524539089466943&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-vallarta",
      "poi_latitude": "36.2843743",
      "poi_longitude": "-88.3074115",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-642-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-771d-726b-a0da-fc0a675ff2b1",
        "storage_key": "property/6767906449167518/019e46ea-771d-726b-a0da-fc0a675ff2b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-plStqie4gRPzbrkbgWYws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d3df7448-5208-4651-ba78-172c1c12d6ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "117 Memorial Dr, Paris, TN 38242, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Customers consistently praise this home improvement store for its clean and well-organized environment, along with its good selection of items and ample parking. Reviewers also frequently mention the friendly and knowledgeable staff.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-55be-70db-821b-84804a421f9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-55be-70db-821b-84804a421f9c",
        "storage_key": "property/6767906449167518/019e46ea-55be-70db-821b-84804a421f9c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TN-Paris/1789?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1789-_-na-_-0-_-0&y_source=1_MTE4MzkyOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9993416346326422128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.284114",
      "poi_longitude": "-88.304864",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-641-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-776c-71bf-a9d2-fb151869e9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-776c-71bf-a9d2-fb151869e9f9",
        "storage_key": "property/6767906449167518/019e46ea-776c-71bf-a9d2-fb151869e9f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfz09Ud2ie4gRcFJeNzi_r4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8172554f-c2df-4b84-a462-3b52ec3e2762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1059 Mineral Wells Ave, Paris, TN 38242, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-55be-70db-821b-83d4cd43b260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-55be-70db-821b-83d4cd43b260",
        "storage_key": "property/6767906449167518/019e46ea-55be-70db-821b-83d4cd43b260.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tn/paris/paris/025/00391?cid=loc_02500391_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=170764490785318660&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "36.2876962",
      "poi_longitude": "-88.3081591",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-644-1075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773d-77d8-a752-4da16b716c61",
        "storage_key": "property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyh1atyie4gRBGeCTWatXgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b282d1d3-751c-4c05-a693-e058626324ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Yoders Country Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "75 Anderson Rd, Paris, TN 38242, USA",
      "poi_short_description": "Fresh, home-grown grub and bakery selling pre-packaged and homemade goods like bread and pastries, plus cheese.",
      "poi_long_description": "People say this store offers a wide variety of unique grocery items, including deli meats, cheeses, spices, and baked goods. Visitors also highlight the friendly and helpful staff, who create a welcoming atmosphere. They also mention the store is immaculate and well-stocked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-58cd-7447-90a0-4536c2d164a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-58cd-7447-90a0-4536c2d164a3",
        "storage_key": "property/6767906449167518/019e46ea-58cd-7447-90a0-4536c2d164a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=669216179941513946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yoders-country-store",
      "poi_latitude": "36.2936677",
      "poi_longitude": "-88.42391339999999",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 731-644-7535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773d-77d8-a752-4da16b716c61",
        "storage_key": "property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfE8ql--e4gR2ppb65GISQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0f3cb856-89df-4cc9-83e2-dfb737ea82c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "bealls",
      "poi_type": "Shopping & Retail",
      "poi_address": "1023 Mineral Wells Ave Ste G, Paris, TN 38242, USA",
      "poi_short_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_long_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-586c-70ee-bca3-abce1348938d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-586c-70ee-bca3-abce1348938d",
        "storage_key": "property/6767906449167518/019e46ea-586c-70ee-bca3-abce1348938d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bealls.com/tn/paris/1023-mineral-wells-ave",
      "poi_directions_map_url": "https://maps.google.com/?cid=17165642454828382961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bealls",
      "poi_latitude": "36.28968380000001",
      "poi_longitude": "-88.3119248",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-641-2269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-776c-71bf-a9d2-fb151869e9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-776c-71bf-a9d2-fb151869e9f9",
        "storage_key": "property/6767906449167518/019e46ea-776c-71bf-a9d2-fb151869e9f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCWaFGNqie4gR8fpofd2cOO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_5db4db86-ce96-4943-8317-69f64dc8cdcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Lakeway IGA",
      "poi_type": "Shopping & Retail",
      "poi_address": "2601 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "Homey grocery store chain stocking fresh produce, meats and other comestibles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-55d1-767e-86c7-ffbba4e48894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-55d1-767e-86c7-ffbba4e48894",
        "storage_key": "property/6767906449167518/019e46ea-55d1-767e-86c7-ffbba4e48894.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lakeway.iga.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=140978612772975403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lakeway-iga",
      "poi_latitude": "36.320353",
      "poi_longitude": "-88.2757621",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-642-1252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773d-77d8-a752-4da16b716c61",
        "storage_key": "property/6767906449167518/019e46ea-773d-77d8-a752-4da16b716c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcoB65mje4gRK7NCJ03b9AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dd1c6c1c-634f-43d6-908c-8ae8ba1b208c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "W. G. Rhea Public Library",
      "poi_type": "Education",
      "poi_address": "400 W Washington St, Paris, TN 38242, USA",
      "poi_short_description": "Public destination for books, computers, movie DVDs and wi-fi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-609c-76a8-9b26-bdf0824b039e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-609c-76a8-9b26-bdf0824b039e",
        "storage_key": "property/6767906449167518/019e46ea-609c-76a8-9b26-bdf0824b039e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wgrhealibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15475861424186444859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "w-g-rhea-public-library",
      "poi_latitude": "36.3030277",
      "poi_longitude": "-88.32867069999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 731-642-1702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773f-771e-9a17-f6b354931393",
        "storage_key": "property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLYF909O8e4gRO8zNffhNxdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e4790f85-9128-4df3-a050-956ed15e8033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Bethel University Physician Assistant Program",
      "poi_type": "Education",
      "poi_address": "302b Tyson Ave, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-5fd9-704e-80c3-8efee8bb95a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-5fd9-704e-80c3-8efee8bb95a3",
        "storage_key": "property/6767906449167518/019e46ea-5fd9-704e-80c3-8efee8bb95a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bethelu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3673813762197726853&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethel-university-physician-assistant-program",
      "poi_latitude": "36.2969807",
      "poi_longitude": "-88.3118456",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-407-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773f-771e-9a17-f6b354931393",
        "storage_key": "property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz2Y_oCeje4gRhaa86iYC_DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0200ed01-7bc2-4390-9823-e6f6bc68b2d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Country Lane Preschool",
      "poi_type": "Education",
      "poi_address": "4000 TN-218, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2714554897190270845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "country-lane-preschool",
      "poi_latitude": "36.2765356",
      "poi_longitude": "-88.2730414",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 731-642-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-773f-771e-9a17-f6b354931393",
        "storage_key": "property/6767906449167518/019e46ea-773f-771e-9a17-f6b354931393.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz-sYOMaje4gRfbdS8ksJrCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_669e019a-6e37-4a37-9cdd-146774902bc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Patriot Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-622e-720b-9d42-82f97f13a621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-622e-720b-9d42-82f97f13a621",
        "storage_key": "property/6767906449167518/019e46ea-622e-720b-9d42-82f97f13a621.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stadiumconnection.com/tn/stadium.php?id=4918",
      "poi_directions_map_url": "https://maps.google.com/?cid=8474663729633762628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patriot-stadium",
      "poi_latitude": "36.2971666",
      "poi_longitude": "-88.2916374",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7762-761a-99b0-d8230dac27fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7762-761a-99b0-d8230dac27fa",
        "storage_key": "property/6767906449167518/019e46ea-7762-761a-99b0-d8230dac27fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMdZ4A_uje4gRRB2168INnHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_30647cda-ad71-4bda-abab-dca5e358397d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Paris Henry County Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "614 N Poplar St, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-64fd-755b-a7dc-b0620148aec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-64fd-755b-a7dc-b0620148aec2",
        "storage_key": "property/6767906449167518/019e46ea-64fd-755b-a7dc-b0620148aec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.phchc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10933086796318604891&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paris-henry-county-heritage-center",
      "poi_latitude": "36.3079202",
      "poi_longitude": "-88.3256483",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 731-642-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7737-74b1-b5fd-39bc7ad8e537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7737-74b1-b5fd-39bc7ad8e537",
        "storage_key": "property/6767906449167518/019e46ea-7737-74b1-b5fd-39bc7ad8e537.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVhDFs28e4gRW34V6YMgupc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d620b466-0069-4ced-8749-a5cb86b500a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Paris Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2101 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6379-7779-aa04-4cf9070b63b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6379-7779-aa04-4cf9070b63b7",
        "storage_key": "property/6767906449167518/019e46ea-6379-7779-aa04-4cf9070b63b7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10709046881596931171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paris-veterinary-clinic",
      "poi_latitude": "36.3156736",
      "poi_longitude": "-88.2843103",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 731-642-2263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ733vGKCje4gRY_yWXGYtnpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f7f3236d-e621-4ef3-b146-eaefbe329f2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Mineral Wells Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "1116 Volunteer Dr, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-65ca-7237-b5b0-490b84a9956a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-65ca-7237-b5b0-490b84a9956a",
        "storage_key": "property/6767906449167518/019e46ea-65ca-7237-b5b0-490b84a9956a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mineralwellsanimalclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6778559739740369061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mineral-wells-animal-clinic",
      "poi_latitude": "36.2850386",
      "poi_longitude": "-88.30399709999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-642-5699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_cwi-eie4gRpTD9PytIEl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_11e78224-9263-4cac-915e-0510b7e8015e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "X9 Nails Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "101 N Brewer St, Paris, TN 38242, USA",
      "poi_short_description": "Nail salon providing pedicures and manicures, including intricate designs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6436-7265-8a8a-6a34b11c6b6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6436-7265-8a8a-6a34b11c6b6a",
        "storage_key": "property/6767906449167518/019e46ea-6436-7265-8a8a-6a34b11c6b6a.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://x9nailsandspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17760765083579054440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "x9-nails-spa",
      "poi_latitude": "36.3019384",
      "poi_longitude": "-88.32398789999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 731-924-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ-WsKm9e4gRaPnjMb7pevY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_425193d8-05b8-49f5-8301-aad76e0c970c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Lakeway Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2701 E Wood St, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6571-719f-825a-ef9d33448379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6571-719f-825a-ef9d33448379",
        "storage_key": "property/6767906449167518/019e46ea-6571-719f-825a-ef9d33448379.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://reviews.vet/tn/paris/veterinarians/lakeway-animal-clinic-ChIJv5ys5pCje4gRSJjyJ-lfgHY",
      "poi_directions_map_url": "https://maps.google.com/?cid=8538930348496689224&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lakeway-animal-clinic",
      "poi_latitude": "36.3228666",
      "poi_longitude": "-88.2730796",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 731-644-9933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ys5pCje4gRSJjyJ-lfgHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ea01fd16-c17a-4bc2-ac04-a5433b2f95a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "UFIT",
      "poi_type": "Health and Wellness",
      "poi_address": "2323 Lakeway Cir, Paris, TN 38242, USA",
      "poi_short_description": "Open 24/7, this gym features free tanning, and equipment for powerlifting, bodybuilding, and CrossFit.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-66f9-7359-888a-4a4a164f1a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-66f9-7359-888a-4a4a164f1a59",
        "storage_key": "property/6767906449167518/019e46ea-66f9-7359-888a-4a4a164f1a59.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/Ultimate-Fitness-of-Paris-TN-581852328884743/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2870364885211715659&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ufit",
      "poi_latitude": "36.3168349",
      "poi_longitude": "-88.279955",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 731-924-4002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8blZYaje4gRS5jMvqeV1Sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2db420dc-9847-4f20-a53a-bda514219373",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "SOHO Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "1150 Mineral Wells Ave, Paris, TN 38242, USA",
      "poi_short_description": "Nail salon offering a variety of services, including massages, in a soothing space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-688f-773e-b65c-6261e83e0b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-688f-773e-b65c-6261e83e0b50",
        "storage_key": "property/6767906449167518/019e46ea-688f-773e-b65c-6261e83e0b50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/sohonailspaparis/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052230171998985544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "soho-nail-spa",
      "poi_latitude": "36.2827489",
      "poi_longitude": "-88.3096597",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-407-7401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xsFqMSie4gRSJ26hiuzWyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_f0c7bf2b-59bb-497b-b4ed-57b30dffdc68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Dempsey's Barbershop of Paris, TN",
      "poi_type": "Health and Wellness",
      "poi_address": "205 W Wood St, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-699d-71a6-a8f8-137b02d6c2f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-699d-71a6-a8f8-137b02d6c2f5",
        "storage_key": "property/6767906449167518/019e46ea-699d-71a6-a8f8-137b02d6c2f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985083879602252270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dempseys-barbershop-of-paris-tn",
      "poi_latitude": "36.3017261",
      "poi_longitude": "-88.3269861",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 731-208-3588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzfr1mC9e4gR7umPR5bbcpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3eb4ed11-d4fe-4e3d-8252-e33f02a5ee49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Flex Fitness - Paris",
      "poi_type": "Health and Wellness",
      "poi_address": "601 Spruce St, Paris, TN 38242, USA",
      "poi_short_description": "Gym featuring clean equipment and friendly staff, plus fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-68df-70bb-86c7-442caf34baeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-68df-70bb-86c7-442caf34baeb",
        "storage_key": "property/6767906449167518/019e46ea-68df-70bb-86c7-442caf34baeb.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "http://flexfitnesstn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11839866958812516536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flex-fitness---paris",
      "poi_latitude": "36.2895731",
      "poi_longitude": "-88.31638799999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-644-3539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDSkyONGie4gRuJDny0SoT6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3f8179bc-bc50-4b7c-8c1a-5eb489598b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Cost Cutters - Paris, TN",
      "poi_type": "Health and Wellness",
      "poi_address": "1210 Mineral Wells Ave, Paris, TN 38242, USA",
      "poi_short_description": "Chain hair salon inside Walmart providing cuts, coloring, and perms, plus hair-care products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-68b6-753d-8f6b-d19c9dc9de3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-68b6-753d-8f6b-d19c9dc9de3f",
        "storage_key": "property/6767906449167518/019e46ea-68b6-753d-8f6b-d19c9dc9de3f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costcutters.com/locations/nearme/haircut/tn/paris/1210-mineral-wells-drive/17332",
      "poi_directions_map_url": "https://maps.google.com/?cid=10537151626467265365&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cost-cutters---paris-tn",
      "poi_latitude": "36.2810549",
      "poi_longitude": "-88.3080196",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-641-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7747-76ad-aa9b-3310c6bd36f6",
        "storage_key": "property/6767906449167518/019e46ea-7747-76ad-aa9b-3310c6bd36f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_PEpdO8e4gRVcsCeJN7O5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_949e78f0-ed53-40c1-ab86-32554e1be3a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "West Tennessee Healthcare Henry County Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Tyson Ave, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6ae4-709f-ac2f-f99d3c06e256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6ae4-709f-ac2f-f99d3c06e256",
        "storage_key": "property/6767906449167518/019e46ea-6ae4-709f-ac2f-f99d3c06e256.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "https://www.wth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5639611095806449220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-tennessee-healthcare-henry-county-hospital",
      "poi_latitude": "36.2962978",
      "poi_longitude": "-88.3108464",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-642-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-775b-7159-be3b-e43f3c3683d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-775b-7159-be3b-e43f3c3683d1",
        "storage_key": "property/6767906449167518/019e46ea-775b-7159-be3b-e43f3c3683d1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46PW1iCje4gRRBblZGnsQ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d9005be2-fc8a-4dca-b35c-557eacfad3d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Griffey Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "430 S Lake St, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456167715915108410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "griffey-clinic",
      "poi_latitude": "36.2962619",
      "poi_longitude": "-88.3131171",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 731-642-3024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-775b-7159-be3b-e43f3c3683d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-775b-7159-be3b-e43f3c3683d1",
        "storage_key": "property/6767906449167518/019e46ea-775b-7159-be3b-e43f3c3683d1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4X3sxieje4gROhBL3znG9i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_6e8c6e55-da2b-407d-861e-4ad3f5aca104",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Eiffel Tower Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1020 Maurice Fields Dr, Paris, TN 38242, USA",
      "poi_short_description": "Park, pool and tower featuring a replica Eiffel Tower and a splash pad.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, a splash pad, a pool, tennis courts, and trails. They highlight the clean and well-maintained facilities, and the easy access and ample parking. They also like the replica Eiffel Tower, which provides a unique photo opportunity.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6e16-71d9-8df5-dc8f9751562f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6e16-71d9-8df5-dc8f9751562f",
        "storage_key": "property/6767906449167518/019e46ea-6e16-71d9-8df5-dc8f9751562f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://paristn.gov/departments/parks-recreation/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3698745295072161198&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eiffel-tower-park",
      "poi_latitude": "36.2869684",
      "poi_longitude": "-88.3017845",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 731-644-2517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7758-771c-b47a-2aafca97802d",
        "storage_key": "property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4WMBeeie4gRrm1swz-VVDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aea69b0f-a895-4c36-b497-398d7e9877ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "McNeill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1315 Edwards St, Paris, TN 38242, USA",
      "poi_short_description": "Public park with a playground, athletic fields, and disc golf, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6e48-751c-b603-08f49f21fb52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6e48-751c-b603-08f49f21fb52",
        "storage_key": "property/6767906449167518/019e46ea-6e48-751c-b603-08f49f21fb52.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18183002696745705529&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcneill-park",
      "poi_latitude": "36.2960548",
      "poi_longitude": "-88.34694669999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7758-771c-b47a-2aafca97802d",
        "storage_key": "property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yBvTeC8e4gROWB_cZ0AV_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dc3a75a3-64b4-45d6-bcb4-2b30064ca19d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Paris Splash pad",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1025 Volunteer Dr, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6ec4-737d-b764-a81e175cde36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6ec4-737d-b764-a81e175cde36",
        "storage_key": "property/6767906449167518/019e46ea-6ec4-737d-b764-a81e175cde36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=895250346655096429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paris-splash-pad",
      "poi_latitude": "36.2859415",
      "poi_longitude": "-88.301999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7758-771c-b47a-2aafca97802d",
        "storage_key": "property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VN5CBSje4gRbR5scXKRbAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_021d1d10-942e-4b5a-8188-7fca7edb4dc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Ogburn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "539 E Washington St, Paris, TN 38242, USA",
      "poi_short_description": "Clean park for children and adults featuring a playground, basketball court and skate park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-6e18-7689-a0df-eb926837fc49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-6e18-7689-a0df-eb926837fc49",
        "storage_key": "property/6767906449167518/019e46ea-6e18-7689-a0df-eb926837fc49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://paristn.gov/departments/parks-recreation/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4614979223965500130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ogburn-park",
      "poi_latitude": "36.3037573",
      "poi_longitude": "-88.3133007",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 731-644-2517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7758-771c-b47a-2aafca97802d",
        "storage_key": "property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9S-baCWje4gR4oJFKiezC0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d3bad57-67c9-4648-ade3-1672067cee9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Atkins Porter Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Highland St, Paris, TN 38242, USA",
      "poi_short_description": "Spacious dog park with agility equipment, plus an area for small dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-71d1-73a1-af57-90d593ef1186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-71d1-73a1-af57-90d593ef1186",
        "storage_key": "property/6767906449167518/019e46ea-71d1-73a1-af57-90d593ef1186.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17947374456961651139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "atkins-porter-dog-park",
      "poi_latitude": "36.2999558",
      "poi_longitude": "-88.31739329999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-7758-771c-b47a-2aafca97802d",
        "storage_key": "property/6767906449167518/019e46ea-7758-771c-b47a-2aafca97802d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJU8VxLXije4gRw1EetvrhEfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dcb96bcf-9fbc-4e40-bbe5-375ae633cdf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "poi_name": "Henry County Airport (PHT/KPHT)",
      "poi_type": "Transportation & Transit",
      "poi_address": "1949 Diggs Rd, Paris, TN 38242, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-71d5-7549-82b7-32f30af50c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46ea-71d5-7549-82b7-32f30af50c32",
        "storage_key": "property/6767906449167518/019e46ea-71d5-7549-82b7-32f30af50c32.webp",
        "width": 1280,
        "height": 639
      },
      "poi_business_url": "https://henrycountytn.org/henry-county-airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1909513433811491596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-county-airport-phtkpht",
      "poi_latitude": "36.3412246",
      "poi_longitude": "-88.3779144",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 731-644-7933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167518/019e46ea-776c-71bf-a9d2-f51565dc1eb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46ea-776c-71bf-a9d2-f51565dc1eb5",
        "storage_key": "property/6767906449167518/019e46ea-776c-71bf-a9d2-f51565dc1eb5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5GIjYm7e4gRDJsr3Fn0fxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9e0dadb5a80246b7f5f1c326",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b719a8324a56955eb99dec21",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_f0601b47be81cd521385ae30",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_50ec67baa652d08fa876772e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c6f6812cecefef2eb67a512b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_04ffdc3a-2e4c-4b38-8e49-04e059b476ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "rating": "5.0",
      "name": "Cheri Curtis",
      "text": "I moved here a month ago from another local apartment complex. In comparison this apartment is bigger, in better condition and has made my life feel so much more comfortable. I love it and the kids have settled in well. Best decision I made was to move.",
      "date": "2025-10-24",
      "title": ""
    },
    {
      "id": "custom_fd470aca-840e-43a5-96fb-1a2556871a34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "rating": "5.0",
      "name": "Fisk Brown Emmie",
      "text": "It looks good and nice here I love the bed rooms",
      "date": "2024-11-21",
      "title": "false"
    },
    {
      "id": "custom_72365e2f-74d6-4710-a651-72f6a661190e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "rating": "5.0",
      "name": "Kevin Guffey",
      "text": "Friendly environment",
      "date": "2025-09-20",
      "title": ""
    },
    {
      "id": "custom_c26abadd-e642-4a2c-aae0-bfb4bd5fb688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "rating": "5.0",
      "name": "Kayla B.",
      "text": "Management is amazing! Very happy here!!!",
      "date": "2019-11-01",
      "title": ""
    },
    {
      "id": "custom_b8f6518b-0644-49b9-8946-7f316f7923d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "rating": "5.0",
      "name": "Thomas Shelton (Big-Tee)",
      "text": "Good",
      "date": "2025-09-04",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-cc95-71e7-a167-5ff0fed3e9af",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Park Place Village of Paris Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518"
    },
    {
      "lead_collector_id": "019ed0ea-cd2e-749b-9ee1-73e5ed1d81b4",
      "lead_source": "LANDING_PAGE",
      "name": "Park Place Village of Paris Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-paris-tn",
      "search_query": "apartments with air conditioning paris tn",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Paris, TN",
      "h2_subtitle": "Discover comfortable living in Paris, TN with central air apartments. Enjoy the convenience and comfort of climate-controlled homes in our community.",
      "page_copy": "Welcome to Park Place Village of Paris, where comfort and convenience meet. Enjoy living in our spacious apartments with air conditioning in Paris, TN, designed to offer you the perfect balance of modern amenities and cozy charm. Our community is located in the heart of Paris, surrounded by local charm and essential conveniences. \n\nEach apartment at Park Place Village is thoughtfully equipped with central air conditioning, providing you a comfortable lifestyle no matter the season. Experience the ease of full-sized washer and dryer hookups, and take advantage of on-site laundry facilities when needed. Our on-site professional management team is dedicated to ensuring a pleasant living experience, complemented by tasteful features such as mini blinds and a host of other amenities. Choose Park Place Village for your next home and relish in quality living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning - Paris, TN",
      "seo_description": "Find apartments with air conditioning in Paris, TN at Park Place Village. Enjoy comfortable living with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "washer-dryer-hookups-apartment-henry-county",
      "search_query": "washer dryer hookups apartment henry county",
      "category": "Amenity",
      "h1_title": "Washer Dryer Hookups Apartments in Henry County",
      "h2_subtitle": "Find your ideal apartment with washer dryer hookups in Henry County. Discover convenience and comfort at Park Place Village in Paris, TN.",
      "page_copy": "Park Place Village of Paris offers the perfect solution for those seeking a washer dryer hookups apartment in Henry County. With spacious layouts and thoughtful amenities, our community provides everything you need for a comfortable lifestyle. Located conveniently in Paris, TN, residents enjoy easy access to local attractions and necessities.\n\nOur apartments are designed to enhance your living experience, featuring full-size washer and dryer hookups ready for use. In addition to this convenience, you'll find on-site laundry facilities available for your use. Enjoy the peace of mind that comes with on-site professional management, dedicated to maintaining a pleasant community. At Park Place Village, you'll appreciate the attention to detail that makes apartment living enjoyable and hassle-free.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Hookups Apartments - Henry County",
      "seo_description": "Explore washer dryer hookups apartments in Henry County at Park Place Village. Offering modern amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartment-with-dishwasher-paris-tn",
      "search_query": "apartment with dishwasher paris tn",
      "category": "Amenity",
      "h1_title": "Apartment with Dishwasher in Paris, TN",
      "h2_subtitle": "Looking for an apartment with a dishwasher in Paris, TN? Discover the convenience and modern living at Park Place Village, where comfort meets functionality.",
      "page_copy": "Discover modern living at Park Place Village of Paris, offering apartments designed with convenience in mind, including features like an apartment with a dishwasher in Paris, TN. Our community provides residents with modern comforts and essential amenities, nestled in the charming city of Paris.\n\nWhile our homes offer a range of amenities like central air conditioning and full-size washer dryer hookups, we ensure maintenance-free living with on-site professional management. Although specific apartment amenities such as a dishwasher are thoughtfully integrated when possible, our commitment remains in providing a superior living experience. Engage in a lifestyle that blends comfort, convenience, and community in a location that truly feels like home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dishwasher - Paris, TN",
      "seo_description": "Explore our apartments with modern amenities, including dishwasher options, in Paris, TN at Park Place Village. Enjoy comfort and convenience in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "private-patio-apartments-in-paris",
      "search_query": "private patio apartments in paris",
      "category": "Amenity",
      "h1_title": "Private Patio Apartments in Paris",
      "h2_subtitle": "Discover private patio apartments in Paris at Park Place Village. Enjoy your own outdoor space in a community designed for comfort and style.",
      "page_copy": "At Park Place Village of Paris, experience the charm of private patio apartments, offering residents a delightful outdoor space to relax and unwind. Located in the heart of beautiful Paris, TN, our community combines modern living with natural serenity, providing the perfect balance for a fulfilling lifestyle.\n\nEach apartment is crafted with comfort in mind, featuring amenities that include central air conditioning, full-size washer and dryer hookups, and on-site professional management ensuring a hassle-free living experience. Whether you cherish a quiet outdoor morning coffee or an evening under the stars, our private patios offer a peaceful retreat in a vibrant community setting. Choose Park Place Village, where every apartment is designed to feel like a home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Patio Apartments - Paris, TN",
      "seo_description": "Find private patio apartments in Paris, TN at Park Place Village. Enjoy outdoor living spaces in a welcoming community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "walk-in-closets-apartment-rentals-38242",
      "search_query": "walk in closets apartment rentals 38242",
      "category": "Amenity",
      "h1_title": "Walk-In Closets Apartment Rentals in 38242",
      "h2_subtitle": "Explore apartment rentals with walk-in closets in the 38242 area. Experience spacious living at Park Place Village, perfectly situated in Paris, TN.",
      "page_copy": "Park Place Village of Paris offers exceptional apartment rentals with walk-in closets in the 38242 area, providing ample storage space and enhanced living comfort. Nestled in Paris, TN, our apartments are designed to meet the needs of modern lifestyles, combining practicality with style.\n\nBeyond spacious closets, residents enjoy a range of amenities including central air conditioning and full-size washer and dryer hookups. On-site professional management ensures a seamless living environment, while the community's location offers convenience and charm. Discover the peace of mind and luxury of having ample storage with the walk-in closets at Park Place Village, where the details make all the difference.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closets Apartments - Rentals in 38242",
      "seo_description": "Discover apartment rentals with walk-in closets in the 38242 area at Park Place Village. Enjoy spacious living in a modern, well-managed community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-paris-tn",
      "search_query": "two bedroom apartments Paris TN",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Paris, TN",
      "h2_subtitle": "Searching for two bedroom apartments in Paris, TN? Park Place Village offers spacious layouts and a welcoming community atmosphere.",
      "page_copy": "Experience the spacious comfort of two bedroom apartments at Park Place Village in Paris, TN. Our community is designed with residents in mind, offering roomy layouts that are perfect for those seeking additional space.\n\nEach apartment includes modern amenities such as central air conditioning, full-size washer and dryer hookups, and on-site laundry facilities. Our professional management team is committed to enhancing your living experience, providing maintenance services and ensuring a well-kept environment. Make Park Place Village your new home and enjoy the great combination of style, function, and community in our two bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Paris, TN",
      "seo_description": "Find spacious two bedroom apartments in Paris, TN at Park Place Village. Ideal layouts and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-henry-county",
      "search_query": "three bedroom apartments near Henry County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Henry County",
      "h2_subtitle": "Discover spacious three bedroom apartments near Henry County at Park Place Village. Ideal for those seeking roominess and convenience in Paris, TN.",
      "page_copy": "Park Place Village of Paris offers spacious three bedroom apartments conveniently located near Henry County. Our community provides comfortable living spaces with modern amenities tailored to enhance your lifestyle.\n\nEach apartment is thoughtfully designed, featuring amenities like central air conditioning, mini blinds, and full-size washer and dryer hookups. Our on-site professional management team ensures a seamless living experience, handling maintenance and fostering a community atmosphere. Choose Park Place Village near Henry County and enjoy the perfect blend of comfort, convenience, and style in our three bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - Near Henry County",
      "seo_description": "Find three bedroom apartments near Henry County at Park Place Village, offering spacious living and modern amenities in Paris, TN.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "four-bedroom-rentals-paris-38242",
      "search_query": "four bedroom rentals in Paris 38242",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Rentals in Paris, 38242",
      "h2_subtitle": "Looking for four bedroom rentals in Paris, TN, 38242? Park Place Village offers spacious living solutions for you.",
      "page_copy": "At Park Place Village in Paris, TN, we offer expansive four bedroom rentals perfect for those in need of extra space in the 38242 area. Our homes provide ample room and comfort while enjoying top-tier amenities.\n\nResidents benefit from central air conditioning, spacious layouts with full-size washer and dryer hookups, and the convenience of on-site laundry facilities. Our professional management team is dedicated to maintaining a relaxed and well-run community environment. Explore the spacious elegance of four bedroom rentals at Park Place Village and experience unmatched living in Paris, TN.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Rentals - Paris, 38242",
      "seo_description": "Explore four bedroom rentals in Paris, 38242 at Park Place Village. Ideal for those needing extra space with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartments-near-bethel-university-pa-program-tn",
      "search_query": "apartments near Bethel University Physician Assistant Program TN",
      "category": "School",
      "h1_title": "Apartments Near Bethel University PA Program TN",
      "h2_subtitle": "Find convenient apartments near Bethel University Physician Assistant Program in TN at Park Place Village. Ideal for those seeking proximity and comfort.",
      "page_copy": "Discover the perfect living solution at Park Place Village, ideally located for those involved with the Bethel University Physician Assistant Program in TN. Our community offers an excellent choice of apartments, balancing convenience and comfort.\n\nEnjoy a host of amenities including central air conditioning, full-size washer and dryer hookups, and on-site laundry facilities, all managed by our dedicated on-site professional management team. With spacious layouts and a well-maintained community, Park Place Village provides a supportive living environment just a short drive from Bethel University, making it an excellent option for those in the Physician Assistant Program.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bethel University PA Program TN",
      "seo_description": "Discover apartments near Bethel University's PA Program at Park Place Village. Perfect for those seeking comfortable, convenient living in TN.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartments-near-eiffel-tower-park-paris-tn",
      "search_query": "apartments near Eiffel Tower Park Paris TN",
      "category": "Park",
      "h1_title": "Apartments Near Eiffel Tower Park, Paris TN",
      "h2_subtitle": "Explore the convenience of living near Eiffel Tower Park in Paris, TN. Park Place Village offers ideal apartments close to this local gem.",
      "page_copy": "For those looking to reside near one of Paris, Tennessee's most charming attractions, Park Place Village provides an ideal option. Situated close to Eiffel Tower Park, our community offers easy access to a landmark that combines recreation with a unique slice of local culture.\n\nResidents at Park Place Village enjoy amenities such as central air conditioning, on-site professional management, and full-size washer and dryer hookups, ensuring a comfortable lifestyle. Whether you're planning a leisurely day at the park or simply savoring the view, our apartments near Eiffel Tower Park offer the perfect blend of comfort and convenience for anyone seeking a vibrant community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Eiffel Tower Park, Paris TN",
      "seo_description": "Find apartments near Eiffel Tower Park at Park Place Village, Paris TN, ensuring convenient access to local attractions and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartment-community-close-to-mcneill-park-henry-county",
      "search_query": "apartment community close to McNeill Park Henry County",
      "category": "Park",
      "h1_title": "Apartment Community Close to McNeill Park",
      "h2_subtitle": "Discover an apartment community close to McNeill Park in Henry County. Park Place Village offers the ideal location for park enthusiasts.",
      "page_copy": "Nestled in the heart of Henry County, Park Place Village is the perfect apartment community for those who love to be near nature. Just a stone's throw away from the beautiful McNeill Park, our community provides residents with easy access to lush green spaces and outdoor activities.\n\nAt Park Place Village, enjoy modern conveniences such as central air conditioning, on-site professional management, and full-size washer and dryer hookups. Our community is thoughtfully designed to enhance your lifestyle, offering both comfort and convenience. Experience the tranquility of living near McNeill Park while enjoying the amenities and community atmosphere of Park Place Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Community Near McNeill Park, Henry County",
      "seo_description": "Live near McNeill Park, Henry County at Park Place Village. Our community offers modern amenities and convenient access to local parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "living-near-paris-splash-pad-38242",
      "search_query": "living near Paris Splash Pad 38242",
      "category": "Park",
      "h1_title": "Living Near Paris Splash Pad, 38242",
      "h2_subtitle": "Enjoy the perks of living near the Paris Splash Pad, 38242. Park Place Village offers the perfect location and amenities for fun-seekers.",
      "page_copy": "For those seeking a vibrant living experience in Paris, TN, Park Place Village offers the perfect location just minutes from the Paris Splash Pad in zip code 38242. Our community is ideal for those who appreciate the convenience of nearby fun-filled attractions and recreational opportunities.\n\nPark Place Village provides top-notch amenities like central air conditioning, on-site laundry, and full-size washer and dryer hookups to meet your everyday needs. With professional management on-site, residents can enjoy a hassle-free living experience close to the action at the Paris Splash Pad, making our apartments a prime choice for anyone looking to combine leisure and practicality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Paris Splash Pad, 38242",
      "seo_description": "Park Place Village offers ideal living near Paris Splash Pad, 38242, with superior amenities and a friendly community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "apartments-by-ogburn-park-paris-tn",
      "search_query": "apartments by Ogburn Park Paris TN",
      "category": "Park",
      "h1_title": "Apartments by Ogburn Park, Paris TN",
      "h2_subtitle": "Discover the convenience of living in apartments by Ogburn Park, Paris TN. Park Place Village provides an unmatched location and comfortable living.",
      "page_copy": "Park Place Village is the perfect setting for those seeking apartments by Ogburn Park, Paris TN. Located near this picturesque park, our community offers residents a perfect blend of nature and modern living. Immerse yourself in the serenity of park life while enjoying the convenience of our centrally-located apartments.\n\nThe amenities at Park Place Village include central air, on-site laundry facilities, and full-size washer and dryer hookups, ensuring a stress-free lifestyle. Managed professionally on-site, our community prioritizes the well-being and satisfaction of its residents, offering an exceptional living experience right next to Ogburn Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Ogburn Park, Paris TN",
      "seo_description": "Find apartments by Ogburn Park at Park Place Village, Paris TN. Enjoy easy access to green spaces and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167518",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-near-atkins-porter-dog-park-paris",
      "search_query": "dog-friendly apartments near Atkins Porter Dog Park Paris",
      "category": "Park",
      "h1_title": "Dog-Friendly Apartments Near Atkins Porter Dog Park",
      "h2_subtitle": "Live in dog-friendly apartments near Atkins Porter Dog Park in Paris. Park Place Village offers the perfect haven for you and your furry friend.",
      "page_copy": "At Park Place Village, we understand that pets are family. Our dog-friendly apartments are ideally situated near Atkins Porter Dog Park in Paris, making it the perfect home for pet owners. Enjoy daily walks in the park and quality time with your four-legged friend in a community that welcomes pets with open arms.\n\nOur community combines pet-friendly amenities with modern comforts like central air conditioning, on-site laundry facilities, and full-size washer and dryer hookups, ensuring a hassle-free lifestyle. Park Place Village not only offers a warm environment for you and your pet but also provides easy access to vibrant outdoor spaces, perfect for dog lovers and their companions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Atkins Porter Park",
      "seo_description": "Find dog-friendly living at Park Place Village, near Atkins Porter Dog Park Paris. Perfect for you and your pet!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067673727"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685517"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P3GD8NGM"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVYMXNpaEVVRHNuMFEzMWtXS0RJWXc9PSIsInZhbHVlIjoiU096b2VCSEhlY1NRSHAxMEJYL29NQT09IiwibWFjIjoiYTU2NTAzZDEwNGVjMjFhNDJmZjNlMjUzMGE2ZTUwN2Y5OWViYzNjNTI0OGFhMzUyZTdlNzNlZDgwODY3YWYzNCJ9"
    }
  ],
  "custom_repli_id": "12067673727",
  "custom_realpage_id": "5685517",
  "custom_google_gtm_id": "GTM-P3GD8NGM",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVYMXNpaEVVRHNuMFEzMWtXS0RJWXc9PSIsInZhbHVlIjoiU096b2VCSEhlY1NRSHAxMEJYL29NQT09IiwibWFjIjoiYTU2NTAzZDEwNGVjMjFhNDJmZjNlMjUzMGE2ZTUwN2Y5OWViYzNjNTI0OGFhMzUyZTdlNzNlZDgwODY3YWYzNCJ9",
  "custom_audioeye_site_id": "6556fa6c-84e0-4c90-bf3a-74d4a3b081e7",
  "custom_audioeye_site_hash": "f7a50efb41488b7fe44fa4ec1f7e92ed"
};

export const generatedAt = '2026-09-23T21:44:46.837Z';
